import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getLatestActivityRef } from './getLatestActivityRef';
import { getActivitiesByRef } from './getActivitiesByRef';

const defaultLatestActivity = {};

export const getLatestActivityBase = createSelector(
  [getLatestActivityRef, getActivitiesByRef],
  (latestActivityRef, activitiesByRef) => {
    return _get(activitiesByRef, latestActivityRef, defaultLatestActivity);
  }
);
